import React, {Component} from 'react';
import { combineReducers, createStore } from 'redux';
import { connect } from 'react-redux';
import Helmet from "react-helmet";
import { browserHistory } from 'react-router';
import lozad from 'lozad';

import { loadUserFromToken } from '../store/actions/authentication';

import Header from '../containers/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

function mapStateToProps(state) {
   return {
    isAuthenticated: state.authentication.isAuthenticated,
    user: state.user.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadUserFromToken: () => {
      dispatch(loadUserFromToken())
    }
  }
}

class AppContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentWillMount() {
    this.props.loadUserFromToken();
  }

  componentDidMount() {
    // lazy loads elements with default selector as '.lozad'
    const observer = lozad(); 
    observer.observe();
  }

  render() {
    let { children, route, user, isAuthenticated } = this.props;

    return (
      <div>
        <Helmet
          meta={[
            { property: "og:site_name", content: route.meta.site_name},
            { property: "og:type", content: 'website'},
          ]}
        />
        <Header siteName={route.meta.site_name} />
        
        <div className="content_wrapper">
          {children}
        </div>
        <Footer siteName={route.meta.site_name}/>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);

// <Hero path={this.props.location.pathname} />


// WEBPACK FOOTER //
// ./src/views/appContainer.js